import * as yup from 'yup';

// src/helpers/validationSchemas/menu/massUpdateItemSchema.ts
var massUpdateItemSchema = yup.object().shape({
  subcategoryId: yup.number().nullable().typeError("subcategoryRequired").when("categoryId", {
    is: -1,
    then: (schema) => schema.notRequired(),
    otherwise: (schema) => schema
  }).when("$childrenType", ([context], schema) => {
    return context === "subcategory" /* SUBCATEGORY */ ? schema.positive("subcategoryRequired") : schema.notRequired();
  }),
  suggestiveOrdering: yup.boolean().required("required"),
  suggestiveOrderingPrompt: yup.string().trim().when("suggestiveOrdering", {
    is: true,
    then: (schema) => schema.required("promptMessageRequired"),
    otherwise: (schema) => schema.notRequired()
  }),
  suggestiveOrderingItemId: yup.number().integer().when("suggestiveOrdering", {
    is: true,
    then: (schema) => schema.positive("suggestiveOrderingItemRequired"),
    otherwise: (schema) => schema.notRequired()
  })
});

export { massUpdateItemSchema };
